export default {
    computed: {
        mobile() {
            return this.$vuetify.breakpoint.xsOnly;
        },
        mobileOrTablet() {
            return this.$vuetify.breakpoint.mdAndDown;
        }
    }
};
